import React from "react"
import { Fade } from "react-awesome-reveal"
import Logo from "./logo"

const Intro = ({ heroContent, introContent }) => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <Fade triggerOnce>
            <div className="logo">
              <Logo />
            </div>
            <h2 className="logo-text">{heroContent.title}</h2>
          </Fade>
        </div>
      </section>
      <section className="text-header">
        <div className="container">
          <Fade triggerOnce>
            {/* {introContent.title && <h1>{introContent.title}</h1>} */}
            {introContent.subtitle && <h1>{introContent.subtitle}</h1>}
          </Fade>
        </div>
      </section>
    </>
  )
}

export default Intro
